import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { doc, setDoc } from 'firebase/firestore';

// Copy shared firebase config into src
const firebaseConfig = {
    apiKey: "AIzaSyC6LI6dEMrEImYzNQSfTmyduHrX1LnxPdo",
    authDomain: "grizzlybase-3cb4a.firebaseapp.com",
    projectId: "grizzlybase-3cb4a",
    storageBucket: "grizzlybase-3cb4a.firebasestorage.app",
    messagingSenderId: "457967904404",
    appId: "1:457967904404:web:c0a1a9d48dc5f4a5e07681",
    measurementId: "G-2VJ0HC2HTZ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
auth.useDeviceLanguage();

const db = getFirestore(app);

const storage = getStorage(app);
storage.maxOperationRetryTime = 10000;
storage.maxUploadRetryTime = 10000;

export { auth, db, storage };

// Initialize super user
export const initializeSuperUser = async () => {
  console.log('Starting super user initialization...');
  try {
    // Create the collection and document in one go
    const superUserRef = doc(db, 'super_users', 'jared');
    console.log('Created reference:', superUserRef.path);
    
    const superUserData = {
      email: 'jared@heytheremedia.com',
      super_user: true,
      created_at: new Date().toISOString()
    };
    console.log('Attempting to set document with data:', superUserData);
    
    await setDoc(superUserRef, superUserData);
    console.log('Super user document created/updated successfully');
    return true;
  } catch (error) {
    console.error('Error initializing super user:', error);
    throw error;
  }
}; 